import { render, staticRenderFns } from "./comentarios.vue?vue&type=template&id=2455bf02&scoped=true&"
import script from "./comentarios.vue?vue&type=script&lang=js&"
export * from "./comentarios.vue?vue&type=script&lang=js&"
import style0 from "./comentarios.vue?vue&type=style&index=0&id=2455bf02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455bf02",
  null
  
)

export default component.exports